import moment from 'moment';

export function request(id, name, conditions) {
    id = parseInt(id, 10);

    if (conditions.startDate) {
        conditions.startDate = moment(conditions.startDate).startOf('day').toISOString();
    }

    if (conditions.endDate) {
        conditions.endDate = moment(conditions.endDate).endOf('day').toISOString();
    }

    return {
        type: 'CUSTOMERS_GET_ASSET_FLOWS_REQUEST',
        id,
        name,
        conditions
    };
}

export function error(id, name, errors) {
    id = parseInt(id, 10);

    return {
        type: 'CUSTOMERS_GET_ASSET_FLOWS_ERROR',
        id,
        name,
        errors
    };
}

export function finish(id, name, assetFlows) {
    return {
        type: 'CUSTOMERS_GET_ASSET_FLOWS_FINISH',
        assetFlows,
        name,
        id
    };
}

export function clear() {
    return {
        type: 'CUSTOMERS_GET_ASSET_FLOWS_CLEAR'
    };
}
